import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _BudgetResource } from '../../../../core/services/dataBean/EntityCatalog';
import { _BudgetSource } from '../../../../core/services/dataBean/EntityCatalogVdos';

interface ConfigProps {
    date: any;
    budgetIDSTr: string;
    budgetResource: number;
}

interface Props {
    cProps: ConfigProps
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectBudgetSourceForYear = ({ idSelector, onChange, label, cProps }: Props) => {

    const { instance, lista, setLista } = useDataBean(_BudgetSource);
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector) {
            setID(idSelector)
        } else {
            setID(null)
        }
    }, [idSelector])

    useEffect(() => {
        if (cProps.date && cProps.budgetIDSTr && cProps.budgetResource) {
            getLista();
        }
        console.log(cProps)
    }, [cProps.budgetResource])

    const setValue = (e: any) => {
        if (e === "") {
            setID(null); // Sincroniza el estado
            onChange(null);
        } else {
            const parsedValue = parseInt(e, 10);
            setID(parsedValue);
            onChange(parsedValue);
        }
    };


    const getLista = () => {

        instance.getBudgetSourceForYear(cProps.date, cProps.budgetIDSTr, cProps.budgetResource).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Funte de Financiamiento"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value="">...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBudgetSource} >{`${item.DataBeanProperties.Code ?? ""} - ${item.DataBeanProperties.Name ?? ""}`}</option>
                        )
                    })
                }
            </select>
        </>
    )
}